import { createReducer } from "@reduxjs/toolkit";
import { Task } from "../../entities/task";
import { arrayToMap } from "../../helpers";
import {
  deleteTaskSuccess,
  getTaskByIdSuccess,
  getTasksSearchMetadataSuccess,
  getTasksSuccess,
  setTaskFilters,
  setTaskLoading,
  setTaskSearchOpen,
  setSelectedTaskID,
  setStagedTask,
  updateStagedTask,
  setTaskFormOpen,
} from "./taskActions";
import { TaskState } from "./taskState";

function initState(): TaskState {
  return {
    tasks: {},
    searchOpen: false,
    searchMetadata: undefined,
    loading: false,
    stagedTask: undefined,
    selectedTaskID: undefined,
    taskFormOpen: false,
  };
}

export const taskReducer = createReducer(initState(), (builder) => {
  builder.addCase(setTaskLoading, (state, action) => {
    state.loading = action.payload.loading;
    return state;
  });
  builder.addCase(setTaskFormOpen, (state, action) => {
    state.taskFormOpen = action.payload.open;
    return state;
  });
  builder.addCase(setStagedTask, (state, action) => {
    state.stagedTask = action.payload.stagedTask;
    return state;
  });
  builder.addCase(setTaskFilters, (state, action) => {
    state.filters = action.payload.filters;
    return state;
  });
  builder.addCase(setTaskSearchOpen, (state, action) => {
    state.searchOpen = action.payload.searchOpen;
    return state;
  });
  builder.addCase(updateStagedTask, (state, action) => {
    if (!state.stagedTask) return state;
    state.stagedTask = {
      ...state.stagedTask,
      ...action.payload.stagedTask,
    };
    return state;
  });
  builder.addCase(setSelectedTaskID, (state, action) => {
    state.selectedTaskID = action.payload.taskID;
    return state;
  });
  builder.addCase(getTasksSuccess, (state, action) => {
    const tasks = action.payload.tasks;
    state.tasks = arrayToMap<Task>(tasks);
    return state;
  });
  builder.addCase(getTasksSearchMetadataSuccess, (state, action) => {
    state.searchMetadata = action.payload.tasksSearchMetadata;
    return state;
  });
  builder.addCase(deleteTaskSuccess, (state, action) => {
    const taskID = action.payload.taskID;
    if (state.tasks[taskID]) {
      delete state.tasks[taskID];
    }
    return state;
  });
  builder.addCase(getTaskByIdSuccess, (state, action) => {
    const task = action.payload.task;
    if (task) {
      const tasks = { ...state.tasks };
      tasks[task.id] = task;
      state.tasks = tasks;
    }
    return state;
  });
});
